import { MatSort, MatSortModule, Sort, SortDirection } from "@angular/material/sort";
import { Directive, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AuthenticationService } from "../../core/authentication/authentication.service";

const KEY = 'MAT_SORT';

@Directive({
  selector: '[sortingCache]',
  standalone: true,

})
export class SortingDirective implements OnInit {
  sortChangeSubscription: Subscription | undefined;

  get matSort(): MatSortData {
    const key = this.authenticationService.getUserEmail() + window.location.pathname
    return JSON.parse(localStorage.getItem(key + '?' + KEY) || '{}');
    //return JSON.parse(localStorage.getItem(window.location.pathname + '?' + KEY) || '{}');
  }

  set matSort(mat: MatSortData) {
    const key = this.authenticationService.getUserEmail() + window.location.pathname
    localStorage.setItem(key + '?' + KEY, JSON.stringify(mat));
  }

  constructor(
    private authenticationService: AuthenticationService,
    private el: MatSort,
  ) { }

  ngOnInit(): void {
    if (this.matSort) {
      this.el.active = this.matSort.active;
      this.el.direction = this.matSort.direction;
    }
    this.sortChangeSubscription?.unsubscribe();
    this.sortChangeSubscription = this.el.sortChange.subscribe((sort: Sort) => {
      this.matSort = {
        active: sort.active,
        direction: sort.direction
      }
    });
  }
}

interface MatSortData {
  active: string;
  direction: SortDirection;
}
